export default __webpack_public_path__ + "static/media/Banner3_revamp_Hk.33fe5e8a.webp";